module.exports = __webpack_public_path__ + "img/logo3.683e1cfb.png";